import { format, parse, parseISO } from 'date-fns';

/**
 * Parse a string date to an ISO Date object
 * @param stringDate
 * @param format
 */
export const dateFromString = (
  stringDate: string,
  format?: string
): Date | undefined =>
  !!stringDate ? parseISO(formatDateString(stringDate, format)) : undefined;

/**
 * Converts a string date in a particular format to the correct format
 * for ISO parsing.
 * @param stringDate
 * @param dateFormat
 */
export const formatDateString = (stringDate: string, dateFormat: string) => {
  return dateFormat
    ? format(parse(stringDate, dateFormat, new Date()), 'yyyy-MM-dd')
    : stringDate;
};

/**
 * Shortcut to check if a base value has been provided, and if so, parse the date, otherwise, return today.
 * @param baseValue
 * @param format
 */
export const getValidationDate = (baseValue?: string, format?: string) =>
  baseValue ? dateFromString(baseValue, format) : new Date();

/**
 * Mutate a given date by adding or subtracting days from today (mutatorFn) and validate if the selected date is x many days
 * before or after (rangeFn) the mutated date
 * @param selectedDate
 * @param requiredDate
 * @param baseDate
 * @param rangeFn
 * @param mutatorFn
 * @param format
 */
export const validateDaysBeforeAfter = (
  selectedDate: any,
  requiredDate: any,
  baseDate: any,
  rangeFn: Function,
  mutatorFn: Function,
  format?: string
) => {
  return !!selectedDate
    ? rangeFn(
        selectedDate,
        mutatorFn(getValidationDate(baseDate, format), requiredDate)
      )
    : true;
};

/**
 * Validate if the selected date is before/after (rangeFn) a given date
 * @param selectedDate
 * @param requiredDate
 * @param rangeFn
 * @param format
 */
export const validateMinMaxDate = (
  selectedDate: any,
  requiredDate: string,
  rangeFn: Function,
  format?: string
) => {
  return !!selectedDate
    ? rangeFn(selectedDate, dateFromString(requiredDate, format))
    : true;
};
